import React, { useCallback, useRef, useState } from 'react';

import ErrorToast from 'components/shared/toasts/ErrorToast';
import SuccessToast from 'components/shared/toasts/SuccessToast';

interface ToastDispatch {
  type: 'SUCCESS' | 'ERROR';
  message: string;
}

interface ToastContextProviderProps {
  children?: React.ReactNode;
}

const ToastContext = React.createContext<{
  toastDispatch: React.Dispatch<ToastDispatch> | null;
}>({ toastDispatch: null });

const ToastContextProvider: React.FC<ToastContextProviderProps> = ({
  children,
}) => {
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const toastDispatch = useCallback((toastDispatch: ToastDispatch) => {
    if (toastDispatch.type === 'SUCCESS') {
      timeoutRef.current && clearTimeout(timeoutRef.current);
      setErrorMessage(null);
      setSuccessMessage(toastDispatch.message);
      timeoutRef.current = setTimeout(() => {
        setSuccessMessage(null);
      }, 3000);
    }
    if (toastDispatch.type === 'ERROR') {
      timeoutRef.current && clearTimeout(timeoutRef.current);
      setSuccessMessage(null);
      setErrorMessage(toastDispatch.message);
      timeoutRef.current = setTimeout(() => {
        setErrorMessage(null);
      }, 3000);
    }
  }, []);

  return (
    <ToastContext.Provider value={{ toastDispatch }}>
      {children}
      <SuccessToast message={successMessage} />
      <ErrorToast message={errorMessage} />
    </ToastContext.Provider>
  );
};

export default ToastContextProvider;
export { ToastContext };
